const routes = [
  {
    path: ["/"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/privacy-policy"],
    exact: true,
    component: "PrivacyPolicy",
  },
  {
    path: ["/terms-and-conditions"],
    exact: true,
    component: "TermsAndConditions",
  },
];

export default routes;
